import React from "react";
import "./App.css";
import { MdEmail, MdPhone, MdLocationOn, MdVerified } from "react-icons/md";
import { BsBriefcaseFill } from "react-icons/bs";
import { GiSevenPointedStar } from "react-icons/gi";
import { FaReact, FaAngular, FaVuejs, FaSass, FaTrophy, FaMedal, FaGraduationCap, FaCalendarAlt } from "react-icons/fa";
import { GrJs } from "react-icons/gr";
import { SiTypescript } from "react-icons/si";

const imgProfile = process.env.PUBLIC_URL + "/profile_pic.JPG";

const experiences = [
  {
    company: "Thoughtworks",
    role: "Senior Consultant · Mumbai",
    period: "Feb 2025 - Present",
    color: "#a8dafd",
    bullets: [
      "Developed and maintained reusable, accessible Web Components using StencilJS as part of the VerSO Design System for Mercedes-Benz.",
      "Integrated components for cross-framework compatibility (Angular, React, VueJS).",
      "Built GitHub Actions workflows for automated PR build deployments for QA environments.",
    ],
  },
  {
    company: "JPMorganChase",
    role: "SDE - 2 · Mumbai",
    period: "Aug 2022 - Feb 2025",
    color: "#e8ff8b",
    bullets: [
      "Led migration from C#-based vendor app to React-based web application for Futures & Options trading.",
      "Shipped multiple React/TypeScript apps with Ag-Grid for real-time trading views.",
      "Developed a Notification system for trade order status changes.",
      "Implemented test-driven development achieving 30% reduction in dev time.",
    ],
  },
  {
    company: "Globant",
    role: "Senior Software Engineer · Remote",
    period: "Jun 2021 - Aug 2022",
    color: "#ffb17d",
    bullets: [
      "Built Augmented Gatekeeping Feedback Tool from scratch using ReactJS for interviewer feedback.",
      "Developed accessible Stencil JS components for Wizink Bank — 40% dev time reduction.",
      "Served as L1 Panelist assessing frontend candidates.",
    ],
  },
  {
    company: "Tata Consultancy Services",
    role: "Software Developer · Mumbai",
    period: "Jun 2019 - Jun 2021",
    color: "#aab6ff",
    bullets: [
      "Developed analytics dashboard from scratch with Oracle Alta UI Design System.",
      "Built SQL queries and stored procedures for chart data visualizations.",
      "Provided troubleshooting and support ensuring seamless UX.",
    ],
  },
];

const awards = [
  {
    icon: FaTrophy,
    title: "Catalyst Award - JPMorganChase",
    desc: "Awarded for excellence in Q2 2024.",
    color: "#f0eb3f",
    iconSize: 43,
  },
  {
    icon: FaMedal,
    title: "Top 3 - Internshala Web Dev Battle",
    desc: "Amongst Top 3 in Internshala's Web Development Battle, 2019.",
    color: "#3ff0e2",
    iconSize: 37,
  },
  {
    icon: FaGraduationCap,
    title: "Google India Frontend Challenge Scholarship",
    desc: "Front-end Web Developer Track through Udacity.",
    color: "#fe8bbd",
    iconSize: 36,
  },
  {
    icon: MdVerified,
    title: "AWS Certified Cloud Practitioner",
    desc: "",
    color: "#db9cff",
    iconSize: 34,
  },
];

const tickerText =
  "NODEJS ✦ HTML ✦ CSS ✦ JAVASCRIPT ✦ REACT ✦ REDUX ✦ STENCILJS ✦ TYPESCRIPT ✦ ANGULAR ✦ VUEJS";

const navItems = [
  { label: "HOME", target: "home" },
  { label: "EXPERIENCE", target: "experience" },
  { label: "AWARDS & CERTS", target: "awards" },
  { label: "CONTACT", target: "contact" },
];

function scrollTo(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
}

function Navbar() {
  const [active, setActive] = React.useState("HOME");

  function handleNav(item) {
    setActive(item.label);
    scrollTo(item.target);
  }

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <div
          className="logo"
          onClick={() => scrollTo("home")}
          style={{ cursor: "pointer" }}
        >
          pw.
        </div>
        <ul className="nav-links">
          {navItems.map((item) => (
            <li
              key={item.label}
              className={active === item.label ? "nav-active" : ""}
              onClick={() => handleNav(item)}
            >
              {item.label}
            </li>
          ))}
        </ul>
        {/* <button className="dark-toggle" aria-label="Toggle dark mode">
          <BsMoonStarsFill size={22} />
        </button> */}
      </div>
    </nav>
  );
}

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-left">
        <p className="hero-greeting">Hi ! Hola ! Namaste ! I am 👋🏻</p>
        <h1 className="hero-name">
          <span className="name-first">Pratik </span>
          <br />
          <span className="name-last">Wadekar</span>
        </h1>
        <p className="hero-subtitle">
          Building robust, accessible, and scalable web experiences with 6+
          years of frontend expertise.
        </p>
        <div className="hero-cta">
          <button className="btn btn-green" onClick={() => scrollTo("contact")}>
            Contact Me
          </button>
          <button
            className="btn btn-pink"
            onClick={() => scrollTo("experience")}
          >
            View Work
          </button>
        </div>
      </div>
      <div className="hero-right">
        {/* Left column */}
        <div className="skill-float skill-react">
          <FaReact size={62} color="#1a6ebf" />
        </div>
        <div className="skill-float skill-angular">
          <FaAngular size={46} color="#dd0031" />
        </div>
        <div className="skill-float skill-vue">
          <FaVuejs size={46} color="#35495e" />
        </div>
        {/* Profile photo */}
        <div className="profile-photo-wrap">
          <img
            src={imgProfile}
            alt="Pratik Wadekar"
            className="profile-photo"
          />
        </div>
        {/* Right column */}
        <div className="skill-float skill-ts">
          <SiTypescript size={46} color="#ffffff" />
        </div>
        <div className="skill-float skill-sass">
          <FaSass size={46} color="#ffffff" />
        </div>
        <div className="skill-float skill-js">
          <GrJs size={46} color="#333333" />
        </div>
      </div>
    </section>
  );
}

function Ticker() {
  const repeated = `${tickerText} ✦ ${tickerText} ✦ ${tickerText}`;
  return (
    <div className="ticker-wrap">
      <div className="ticker-track">
        <span>{repeated}&nbsp;&nbsp;</span>
        <span aria-hidden="true">{repeated}&nbsp;&nbsp;</span>
      </div>
    </div>
  );
}

function ExperienceCard({ exp, showStar }) {
  return (
    <div className="exp-card" style={{ backgroundColor: exp.color }}>
      {showStar && <GiSevenPointedStar className="card-star" size={72} />}
      <div className="exp-header">
        <div className="exp-title">
          <p className="exp-company">{exp.company}</p>
          <p className="exp-role">{exp.role}</p>
        </div>
        <div className="exp-badge">
          <FaCalendarAlt size={18} />
          <span>{exp.period}</span>
        </div>
      </div>
      <ul className="exp-bullets">
        {exp.bullets.map((b, i) => (
          <li key={i}>→ {b}</li>
        ))}
      </ul>
    </div>
  );
}

function Experience() {
  return (
    <section className="section experience-section" id="experience">
      <h2 className="section-title">
        EXPERIENCE <span className="pink-dot">.</span>
      </h2>
      <div className="exp-timeline">
        {experiences.map((exp, i) => (
          <div className="timeline-row" key={i}>
            <div className="timeline-col">
              <div
                className="timeline-icon-wrap"
                style={{ backgroundColor: exp.color }}
              >
                <BsBriefcaseFill size={22} color="#000" />
              </div>
            </div>
            <ExperienceCard exp={exp} showStar={i === 0} />
          </div>
        ))}
      </div>
    </section>
  );
}

function AwardCard({ award }) {
  const Icon = award.icon;
  return (
    <div className="award-card" style={{ backgroundColor: award.color }}>
      <Icon size={award.iconSize} className="award-icon" />
      <p className="award-title">{award.title}</p>
      {award.desc && <p className="award-desc">{award.desc}</p>}
    </div>
  );
}

function Awards() {
  return (
    <section className="section awards-section" id="awards">
      <h2 className="section-title">
        AWARDS &amp; CERTS <span className="pink-dot">.</span>
      </h2>
      <div className="awards-grid">
        {awards.map((a, i) => (
          <AwardCard key={i} award={a} />
        ))}
      </div>
    </section>
  );
}

function Contact() {
  return (
    <section className="section contact-section" id="contact">
      <h2 className="section-title">
        CONTACT ME <span className="pink-dot">.</span>
      </h2>
      <p className="contact-intro">
        Interested in working together? Let's connect. Always open to new
        opportunities and conversations.
      </p>
      <div className="contact-list">
        <div className="contact-item">
          <div
            className="contact-icon-wrap"
            style={{ backgroundColor: "#ddf240" }}
          >
            <MdEmail size={26} />
          </div>
          <span>pratik.wadekar2810@gmail.com</span>
        </div>
        <div className="contact-item">
          <div
            className="contact-icon-wrap"
            style={{ backgroundColor: "#fff" }}
          >
            <MdPhone size={26} />
          </div>
          <span>+91 - 8806699212</span>
        </div>
        <div className="contact-item">
          <div
            className="contact-icon-wrap"
            style={{ backgroundColor: "#85ceff" }}
          >
            <MdLocationOn size={26} />
          </div>
          <span>Mumbai, IN</span>
        </div>
      </div>
    </section>
  );
}

export default function App() {
  return (
    <div className="page">
      <div className="content-wrapper">
        <main className="main-content">
          <Navbar />
          <Hero />
          <Ticker />
          <Experience />
          <Awards />
          <Contact />
        </main>
      </div>
    </div>
  );
}
